<script>
  import { domainName, recordCreated } from '../stores.js';

  let domain
</script>

<div class="record-box record-instructions">
  <div id="headingRaw" class="box-label">
    <h5>New DMARC Record: <a class="link-arrow" href="https://{$domainName}" target="_blank">{$domainName}</a></h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseNewRecord" aria-expanded="true" aria-controls="collapseNewRecord" aria-label="Close"></button>
  </div>
  <div id="collapseNewRecord" class="box-detail collapse show" aria-labelledby="headingRaw">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Domain</th>
          <th>DNS Record Location</th>
          <th>DMARC record</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{$domainName}</td>
          <td>_dmarc.{$domainName}</td>
          <td>{$recordCreated.raw}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<style>
th:first-child {
  width: 17%;
}
th:last-child {
  width: 50%;
}
</style>
